// Shared by the schedule list ("last execution" column) and the execution
// history screen, so a run is labelled the same way in both places.

const STATUS_CLASS = {
  success: 'bg-success',
  empty: 'bg-warning',
  failed: 'bg-danger',
}

export function executionStatusClass(status) {
  return STATUS_CLASS[status] ? STATUS_CLASS[status] : 'bg-secondary'
}

// "empty" reads differently per schedule type: no reports vs no claims.
export function executionStatusKey(execution) {
  if (!execution) {
    return 'schedule.neverRan'
  }
  if (execution.status === 'success') {
    return 'schedule.historyStatusSuccess'
  }
  if (execution.status === 'failed') {
    return 'schedule.historyStatusFailed'
  }
  return execution.type === 'claim'
    ? 'schedule.historyStatusNoClaims'
    : 'schedule.historyStatusNoReports'
}
